var keyMirror = require('keymirror');

module.exports = keyMirror({
    RESPONSE_RECIEVED: null,
    GET_PORTFOLIO_PROFILES: null,
    ASSIGN_PROFILES_TO_PORTFOLIO: null,
    DELETE_PORTFOLIO_PROFILE: null,
    PORTFOLIO_PROFILE_LIST: null
});